module.exports = __webpack_public_path__ + "img/type(2).c248a37a.png";